import { useSelectionStore } from "../../stores/selectionStore";

/** Body focus-mode dimming must not affect these scene-root overlay groups (stable colors). */
export const FOCUS_DIM_OVERLAY_ROOT_NAMES = new Set([
  "constraint_visualization",
  "tendon_visualization",
  "constraint_markers",
  "__meshOriginMarkerRoot",
  "__axesHelper",
  "__upArrow",
]);

export function isUnderFocusDimExemptOverlay(obj) {
  let p = obj;
  while (p) {
    if (FOCUS_DIM_OVERLAY_ROOT_NAMES.has(p.name)) return true;
    p = p.parent;
  }
  return false;
}

export function selectionFocusBodiesMultiSnapshot(focusModeActive) {
  if (!focusModeActive) return null;
  const sb = useSelectionStore.getState().selectedBodies;
  return sb.length > 1 ? sb : null;
}
